export default {"src":"/_next/static/media/Linktree.5a919019.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};